import { render } from "./AiCheckBlinkCursor.vue?vue&type=template&id=70d98f12&scoped=true"
const script = {}

import "./AiCheckBlinkCursor.vue?vue&type=style&index=0&id=70d98f12&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d98f12"]])

export default __exports__